import type { FunctionComponent } from 'react';

import type { ParagraphProps } from './types';

const headingVariants = {
  h1: 'text-h1 leading-h1',
  h2: 'text-h2 leading-h1',
  h3: 'text-h3 leading-h3',
  h4: 'text-h4 leading-h4',
  'h4-semibold': 'text-h4 leading-h4',
  h5: 'text-h5 leading-8',
  'h5-semibold': 'text-h5 leading-8',
  'subtitle-1': 'text-sm leading-5 uppercase',
  'subtitle-2': 'text-[8px] leading-3 uppercase',
  'text-xl': 'text-xl leading-6',
  'text-lg': 'text-lg leading-6',
  'text-lg-medium': 'text-lg leading-6',
  'text-lg-normal': '!font-normal text-lg leading-6',
  'text-md': 'text-base leading-5',
  'text-md-thin': '!font-thin text-base leading-5',
  'text-base': '!font-normal text-base leading-5',
  'text-base-medium': 'text-base leading-5',
  'text-base-semibold': 'text-base leading-5',
  'text-base-thin': '!font-thin text-base leading-5',
  'text-sm-semibold': 'text-sm leading-4',
  'text-sm': '!font-normal text-sm leading-4',
  'text-sm-thin': '!font-thin text-sm leading-4',
  'text-xs-semibold': 'text-xs leading-4',
  'text-xs': '!font-normal text-xs leading-4'
};

export const Paragraph: FunctionComponent<ParagraphProps> = ({ size, variant = 'text-base', className, children, ...props }) => {
  const classNames = `font-medium not-italic text-dark dark:text-n700_text_dark_mode ${headingVariants[variant]} ${className}`;
  const sizeNumber = typeof size === 'number' ? size : undefined;

  return (
    <p {...props} className={classNames} style={{ fontSize: sizeNumber }}>
      {children}
    </p>
  );
};
